<template>
    <div class="rounded-xl border border-gray-300 bg-gray-100 px-6 py-4">
        <div class="flex items-center gap-4">
            <h3 class="text-md font-semibold text-gray-900">
                {{ title }}
            </h3>

            <button
                v-if="showToggleLink"
                type="button"
                class="ml-auto text-md font-semibold text-blue-600 transition hover:text-blue-700"
                @click="$emit('toggle-link')"
            >
                {{ toggleLinkText }}
            </button>
        </div>

        <div class="mt-6">
            <label
                :for="selectId"
                class="mb-3 block text-sm font-medium text-gray-900"
            >
                {{ label }}
            </label>
            <Combobox
                :options="
                    options.map((resourceOption) => ({
                        value: resourceOption.id,
                        label: resourceOption.title,
                        rightCount:
                            resourceOption.total > 0
                                ? `${Number(resourceOption.total)} ${
                                      this.type === 'flashcards'
                                          ? 'Cards'
                                          : 'Slides'
                                  }`
                                : '',
                    }))
                "
                :placeholder="placeholder || 'Select a resource...'"
                input-classes="border-gray-300"
                v-model="selectedResourceId"
            />
        </div>

        <div class="mt-10 flex justify-end gap-4">
            <button
                type="button"
                class="rounded-md bg-gray-200 px-6 py-2 text-md font-semibold text-gray-700 transition hover:bg-gray-300"
                @click="handleCancel"
            >
                Cancel
            </button>
            <button
                type="button"
                class="rounded-md px-6 py-2 text-md font-semibold text-white transition"
                :class="
                    canAttach
                        ? 'bg-blue-600 hover:bg-blue-700'
                        : 'cursor-not-allowed bg-blue-300'
                "
                :disabled="!canAttach"
                @click="handleAttach"
            >
                {{ attachButtonText }}
            </button>
        </div>
    </div>
</template>

<script lang="ts">
import Combobox from "@/components/ui/forms/Combobox.vue";

export default {
    components: {
        Combobox,
    },
    props: {
        title: {
            type: String,
            required: true,
        },
        label: {
            type: String,
            required: true,
        },
        selectId: {
            type: String,
            required: true,
        },
        type: {
            type: String,
            required: true,
        },
        options: {
            type: Array,
            default: () => [],
        },
        placeholder: {
            type: String,
            default: "",
        },
        attachButtonText: {
            type: String,
            default: "Attach Resource",
        },
        showToggleLink: {
            type: Boolean,
            default: false,
        },
        toggleLinkText: {
            type: String,
            default: "",
        },
    },
    data(): any {
        return {
            selectedResourceId: "",
            isAttaching: false,
        };
    },
    computed: {
        canAttach(): boolean {
            return !!this.selectedResourceId && !this.isAttaching;
        },
    },
    methods: {
        handleCancel() {
            this.selectedResourceId = "";
            this.isAttaching = false;
            this.$emit("cancel");
        },
        handleAttach() {
            if (!this.selectedResourceId || this.isAttaching) {
                return;
            }

            this.isAttaching = true;

            this.$emit("attach", {
                resource_id: this.selectedResourceId,
            });

            this.selectedResourceId = "";
            this.isAttaching = false;
        },
    },
};
</script>
